const fetchCompanies = state => state.companies;
const companyInfo = state => state.companyInfo;
const allCompaniesList = state => state.allCompaniesList;
const companiesCount = state => state.companiesCount;
const companiesNextPage = state => state.companiesNextPage;
const companyWall = state => state.companyWall;
export default {
  fetchCompanies,
  companyInfo,
  allCompaniesList,
  companiesCount,
  companiesNextPage,
  companyWall,
};
